"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Check_base_1 = require("./Check.base");
var Check_styles_1 = require("./Check.styles");
exports.Check = Utilities_1.styled(Check_base_1.CheckBase, Check_styles_1.getStyles, undefined, {
    scope: 'Check'
}, true);
/**
 * Memoized helper for rendering a Check. Always uses fast icons.
 * @param theme - Theme, so the check can be re-rendered if it changes.
 * @param checked - Whether the check is checked.
 * @param className - Class name for styling the check.
 */
exports.getCheck = Utilities_1.memoizeFunction(function (theme, checked, className) {
    return React.createElement(exports.Check, { theme: theme, checked: checked, className: className, useFastIcons: true });
});
//# sourceMappingURL=Check.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Check/Check.js
// module id = 759
// module chunks = 0